<template>
    <div class="d-lg-flex half bg-white w-100">
      <div 
        class="bg order-1 order-md-2 auth-bg d-none d-lg-block" 
        :style="{'background-image': 'url(' + require('@/assets/images/auth/' + $i18n.locale +  '/welcome-np.svg') + ')'}"
      >
      </div>
      <div class="contents order-2 order-md-1">
  
          <div class="container">
              <div class="row align-items-center justify-content-center">
                  <div class="col-md-6 text-center">              

                    <div class="cobalt-auth mb-4 text-lg-center">
                        <img :src="require('@/assets/images/auth/' + $i18n.locale +  '/login.svg')" :alt="$t('auth.registration')" />
                    </div>

                    <p class="cobalt-auth cobalt_color-halfblack mb-4 text-lg-center" v-if="needActivation">
                        {{ $t("auth.needActivation") }}
                    </p>

                    <p class="cobalt-auth cobalt_color-halfblack mb-4 text-lg-center" v-if="needResendCode">
                        {{ $t("auth.needResendCode") }}
                    </p>

                    <form>
                        <div class="form-group cobalt-form-group d-flex justify-content-center has-feedback mb-3" v-if="!needActivation && !needResendCode">
                            <div class="cobalt-input-group">
                                <span class="input-group-text">
                                    <img src="@/assets/images/auth/email.svg" />
                                </span>                            
                                <input type="text" class="form-control cobalt-flat-input cobalt-input-auth" :placeholder="$t('auth.email')"
                                    id="exampleInputLogin" aria-describedby="loginHelp" v-model="authData.login">
                            </div>
                            <small id="loginHelp" class="form-text text-muted"></small>
                        </div>
                        <div class="form-group cobalt-form-group d-flex justify-content-center has-feedback mb-5" v-if="!needActivation && !needResendCode">
                            <div class="cobalt-input-group">
                                <span class="input-group-text">
                                    <img src="@/assets/images/auth/password.svg" />
                                </span>                             
                                <input type="password" class="form-control cobalt-flat-input cobalt-input-auth" :placeholder="$t('auth.password')"
                                    id="exampleInputPassword" v-model="authData.password">
                            </div>
                        </div>       

                        <div class="form-group cobalt-form-group d-flex justify-content-center mb-3" v-if="needResendCode">                            
                            <div class="cobalt-input-group">
                                <span class="input-group-text">
                                    <img src="@/assets/images/auth/email.svg" />
                                </span>                            
                                <input type="text" class="form-control cobalt-flat-input cobalt-input-auth" :placeholder="$t('auth.email')"
                                    id="inputEmail" aria-describedby="activeCodeHelp" v-model="email" required>
                            </div>
                            <small id="inputActiveCode" class="form-text text-muted"></small>
                        </div>    

                        <div class="cobalt-form-group d-flex" v-if="!needActivation && !needResendCode">
                            <button type="button" class="btn cobalt-btn-primary btn-lg flex-fill" @click="tryLogin">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.loading"></span>
                                {{ $t("auth.enter") }}
                            </button>
                            <button type="button" class="btn btn-link ms-3" @click="goForgot">{{ $t("auth.forgotPassword") }}</button>
                        </div>

                        <div class="cobalt-form-group d-flex" v-if="needResendCode">
                            <button type="button" class="btn cobalt-btn-primary btn-lg flex-fill" :disabled="this.loading" @click="doResendCode" >
                                {{ $t("auth.resendCode") }}
                            </button>

                            <button type="button" class="btn btn-link ms-2" @click="goLogin">{{ $t("auth.login") }}</button>
                        </div>

                        <div v-if="authData.errorText != ''">
                            <p class="mt-2 mb-0 text-danger">{{ authData.errorText }}</p>
                        </div>
                        <div class="mt-4">
                            <p class="clarification mt-2">
                                <span>{{ $t("auth.notRegisteredYet") }}</span>
                                <button type="button" class="btn btn-link ms-2" @click="tryRegister">{{ $t("auth.register") }}</button>
                            </p>
                            <LanguageSwitcher />
                        </div>                        
                    </form>
                </div>
            </div>
        </div>
    </div> 
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LanguageSwitcher from '../components/LanguageSwitcher.vue'
import { useUserStore } from '@/stores/userStore'

export default {
    components: {
        LanguageSwitcher
    },
    data() {
        return {
            loading: false,
            needActivation: false,
            needResendCode: false,
            activCode: '',
            email: '',
            authData: {
                login: '',
                password: '',
                errorText: '',
                code: ''
            }
        }
    },
    mounted() {
        this.checkAuthStatus();
    },    
    computed: {
        userStore() {
            return useUserStore()
        },
        code() {
            return this.$route.query.code || null;
        },  
        invite() {
            return this.$route.query.invite || null;
        },                
        isAuthenticated() {
            return this.userStore.isAuthenticated;
        }        
    }, 
    watch: {
        isAuthenticated(newVal) {
            if (newVal) {
                this.$router.push({ name: 'dashboard' });
            }
        }
    },    
    methods: {
        ...mapActions('user', ['login', 'activate', 'resendCode']),
        async checkAuthStatus() {
            if (this.userStore.isAuthenticated) {
                this.$router.push({ name: 'dashboard' });
            }
        },        
        async tryLogin() {
            this.needActivation = false
            this.needResendCode = false
            this.loading = true

            let auth = {
                login: this.authData.login,
                password: this.authData.password
            }

            if (this.invite) {
                auth["code"] = this.invite
            }

            const authResult =await this.userStore.login(auth)

            this.loading = false

            if (this.userStore.user) {
                this.$router.push({ name: 'dashboard' })
            } else {
                if (authResult.code == '2016') {
                    this.needResendCode = true
                } else {
                    this.authData.errorText = this.$t("error.wrongPassword");
                }
            }     
        },
        async tryActive() {
            this.loading = true

            let act = await this.activate(this.activCode)

            this.loading = false

            if (act) {
                this.$router.push({ name: 'dashboard' })
            }
            else {
                this.authData.errorText = this.$t("error.activationFailed")
            }
        },
        async goResendCode() {
            this.needActivation = false
            this.needResendCode = true
        },
        async doResendCode() {
            this.loading = true

            let res = await this.resendCode(this.email)

            this.loading = false

            if (res.code == '2015') {
                this.needActivation = false
                this.needResendCode = false

                this.authData.errorText = this.$t("error.activationAlready")
            } else {
                this.needActivation = true
                this.needResendCode = false
            }
        },
        goLogin() {
            this.needActivation = false
            this.needResendCode = false            
        },
        tryRegister(){
            this.$router.push({ name: 'register' })
        },
        goForgot() {
            this.$router.push({ name: 'forgot' })
        }
    }
}
</script>

<style>
.btn-log {
    --bs-btn-color: #fff !important;
    --bs-btn-bg: #880652 !important;
    --bs-btn-border-color: #065588 !important;
    --bs-btn-hover-color: #fff !important;
    --bs-btn-hover-bg: #054068 !important;
    --bs-btn-hover-border-color: #054068 !important;
    --bs-btn-focus-shadow-rgb: 49, 132, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #054068;
    --bs-btn-active-border-color: #054068;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: #065588;
    --bs-btn-disabled-border-color: #065588;
}

.form-control-log {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #C8D8E8;
    background-clip: padding-box;
    border: none;
    border-radius: 0.375rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.form-control-log:focus {
    color: #000000;
    background-color: #a4b2c0;
    outline: 0;
    box-shadow: 0 0 0 0.1rem rgba(13, 110, 253, 0);
}
</style>